import {NodeType} from 'common/src/modules/nodes/nodes.types';
import {CLStore} from 'common/src/redux/store';
import addOrUpdateCardTool from '../general/addOrUpdateCardTool/addOrUpdateCardTool';
import {locationCardSchema} from '../../schemas/locationCardSchema';
import getLocationFeedTool from './getLocationFeedTool';
import getLocationSetsTool from './getLocationSetsTool';
import {CampaignSetupAgentToolName} from '../../campaignSetupAgent.enums';
import matchStrategyTool from '../strategy/matchStrategyTool';

export default function addOrUpdateLocationCardTool(store: CLStore) {
  return addOrUpdateCardTool({
    store,
    cardType: NodeType.STORE,
    cardSchema: locationCardSchema,
    description: 'Add or update SINGLE Location card. Can search for location feeds and location sets by prompt.',
    tools: [getLocationFeedTool(), getLocationSetsTool(), matchStrategyTool(store)],
    cardSpecificInstructions: `1. If a location feed ID is provided, use it directly. If a location set ID is provided, use it directly. Only use the ${CampaignSetupAgentToolName.GetLocationFeeds} or ${CampaignSetupAgentToolName.GetLocationSets} tools if no ID is provided or if the user provided other search details.
2. If setting the location set in the card, you must set the feed ID of the card to the feed ID of the location set.
3. Use the ${CampaignSetupAgentToolName.MatchStrategy} tool to find the best matching strategy following user's request.`,
  });
}
